<app-tournament-header [hidden]="isThemedStreamView" #header (changeDate)="changeDate($event)" (changeVenue)="changeVenue($event)" [matchType]="matchType" [showExportPdf]="partner?.toLowerCase() === 'tmx'"></app-tournament-header>

<ion-content>
    @if (!isThemedStreamView && (loadedMatchUps?.length > 0 || allowSkipCache)) {
            <ion-searchbar *ngIf="partner?.toLowerCase() !== 'tmx' || (partner?.toLowerCase() == 'tmx' && matchType.toLowerCase() === 'completed')" placeholder="{{ 'Search' | translate }}" (ionInput)="onSearchChange($event)" [debounce]="250"></ion-searchbar>

            @if (allowSkipCache) {
                <ion-buttons slot="end">
                    <ion-button (click)="getMatchesAndSkipCache()">
                        <ion-icon slot="icon-only" name="refresh"></ion-icon>
                    </ion-button>
                </ion-buttons>
            }
    }


    <ion-refresher (ionRefresh)="getMatches(false, true, true, $event)" slot="fixed">
        <ion-refresher-content></ion-refresher-content>
    </ion-refresher>

    @if (!header.isLoading && (matchUps?.length || venues?.length > 0)) {
        @if (matchUps?.length > 0) {
        <ion-row>
            <ion-col class="ion-no-padding" size="12" size-md="4" *ngFor="let matchUp of matchUps">
                <app-tie-match-scoreboard [match]="matchUp"></app-tie-match-scoreboard>
            </ion-col>
        </ion-row>
        } @else if (partner?.toLowerCase() === 'tmx' && venues?.length > 0 && !isLoadingMatches) {
            @for (venue of venues; let i = $index; track i) {
                @for (court of venue?.courts; let j = $index; track j) {
                    <div class="content-width" *ngIf="court?.matchUps?.length > 0">
                        <span class="court-name">{{ court?.courtName }}</span>
                    </div>
                    @for (match of court?.matchUps; let k = $index; track k) {
                        <app-tie-match-scoreboard [match]="match" [venue]="venue" [court]="court"></app-tie-match-scoreboard>
                    }
                }
            }
            @if (canLoadMoreTmxMatches) {
                <ion-infinite-scroll *ngIf="canLoadMoreTmxMatches" (ionInfinite)="loadMoreTmxMatches($event)">
                    <ion-infinite-scroll-content loadingSpinner="bubbles" loadingText="Loading more matches..."></ion-infinite-scroll-content>
                </ion-infinite-scroll>
            }
        }
    } @else {
        <app-empty-page *ngIf="!isLoadingMatches" text="{{'No matches' | translate}}" iconName="tennisball"></app-empty-page>
    }

    @if (isLoadingMatches) {
        <div class="ion-padding content-width">
            <div *ngFor="let i of [].constructor(3)">
                <ion-skeleton-text animated style="width: 100%"></ion-skeleton-text>
                <ion-row>
                    <ion-col size="10">
                        <ion-skeleton-text animated style="width: 100%"></ion-skeleton-text>
                    </ion-col>
                    <ion-col size="2">
                        <ion-skeleton-text animated style="width: 100%"></ion-skeleton-text>
                    </ion-col>
                </ion-row>
                <ion-row>
                    <ion-col size="10">
                        <ion-skeleton-text animated style="width: 100%"></ion-skeleton-text>
                    </ion-col>
                    <ion-col size="2">
                        <ion-skeleton-text animated style="width: 100%"></ion-skeleton-text>
                    </ion-col>
                </ion-row>
                <ion-skeleton-text animated style="width: 100%"></ion-skeleton-text>
                <div style="height: 25px"></div>
            </div>
        </div>
    }

    <ion-fab *ngIf="location.path().includes('/upcoming') && tournament?.partner === 'manual'" vertical="bottom" horizontal="end" slot="fixed">
        <ion-fab-button (click)="addMatchUp()">
            <ion-icon name="add"></ion-icon>
        </ion-fab-button>
    </ion-fab>

    <!-- <ion-infinite-scroll *ngIf="canLoadMoreMatches" (ionInfinite)="getMatches(false, false, $event)">
        <ion-infinite-scroll-content></ion-infinite-scroll-content>
    </ion-infinite-scroll> -->
</ion-content>